<script>
import CustomColorPaletteTab from "./whitelabel/CustomColorPaletteTab.vue"
import CustomCssTab from "@/components/myOrganizations/whitelabel/CustomCssTab.vue";
import CustomUrlsTab from "@/components/myOrganizations/whitelabel/CustomUrlsTab.vue";
import CustomEmailTemplatesTab from "@/components/myOrganizations/whitelabel/CustomEmailTemplatesTab.vue";
import CustomLogosTab from "@/components/myOrganizations/whitelabel/CustomLogosTab.vue";
import CustomFaviconTab from "@/components/myOrganizations/whitelabel/CustomFaviconTab.vue";
import CustomTypographyTab from "@/components/myOrganizations/whitelabel/CustomTypographyTab.vue";
import LargeTabHeader from "@/components/common/tabs/LargeTabHeader.vue";

export default {
  components: {
    LargeTabHeader,
    CustomTypographyTab,
    CustomFaviconTab,
    CustomUrlsTab,
    CustomEmailTemplatesTab,
    CustomLogosTab,
    CustomColorPaletteTab,
    CustomCssTab
  },
  data() {
    return {
      activeTab: 0,
    }
  },
}
</script>

<template>
  <v-container fluid>

    <LargeTabHeader :title="$t('heading.whitelabel')" :subtitle="$t('subheading.whitelabel')" />

    <!--    INITIAL SUBDOMAIN HINT-->
    <v-fade-transition>
      <v-container v-if="!$store.getters.urls.subdomain" id="missing-subdomain-hint">
        <v-row>
          <v-col>
            <v-banner color="info" style="color: white" icon="mdi-information-variant" icon-color="white">
              {{ $t('component.whitelabel.custom.urls.subdomain.has.to.be.initialized.banner') }}
            </v-banner>
          </v-col>
        </v-row>
      </v-container>
    </v-fade-transition>

    <v-divider></v-divider>

    <!-- TABS -->
    <v-row>
      <v-col cols="3">
        <v-tabs v-model="activeTab" show-arrows vertical color="primary">
          <v-tabs-slider></v-tabs-slider>
          <v-tab id="navigate-to-custom-urls" class="justify-start">
            <v-icon>mdi-link-variant</v-icon>
            <span class="pl-1">{{ $t('navigation.urls') }}</span>
          </v-tab>
          <v-tab id="navigate-to-email-templates" class="justify-start" :disabled="!$store.getters.urls.subdomain">
            <v-icon>mdi-email-edit-outline</v-icon>
            <span class="pl-1">{{ $t('navigation.email') }}</span>
          </v-tab>
          <v-tab id="navigate-to-custom-logos" class="justify-start" :disabled="!$store.getters.urls.subdomain">
            <v-icon>mdi-file-image-outline</v-icon>
            <span class="pl-1">{{ $t('navigation.logos') }}</span>
          </v-tab>
          <v-tab id="navigate-to-custom-favicon" class="justify-start" :disabled="!$store.getters.urls.subdomain">
            <v-icon>mdi-compare</v-icon>
            <span class="pl-1">{{ $t('navigation.favicon') }}</span>
          </v-tab>
          <v-tab id="navigate-to-custom-typography" class="justify-start" :disabled="!$store.getters.urls.subdomain">
            <v-icon>mdi-format-font</v-icon>
            <span class="pl-1">{{ $t('navigation.typography') }}</span>
          </v-tab>
          <v-tab id="navigate-to-custom-color-palette" class="justify-start" :disabled="!$store.getters.urls.subdomain">
            <v-icon>mdi-palette-outline</v-icon>
            <span class="pl-1">{{ $t('navigation.color.palette') }}</span>
          </v-tab>
          <v-tab id="navigate-to-custom-css" class="justify-start" :disabled="!$store.getters.urls.subdomain">
            <v-icon>mdi-language-css3</v-icon>
            <span class="pl-1">{{ $t('navigation.custom.css') }}</span>
          </v-tab>
        </v-tabs>
      </v-col>
      <!-- TABS CONTENT -->
      <v-col cols="9">
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <CustomUrlsTab id="custom-urls-tab" />
          </v-tab-item>
          <v-tab-item>
            <CustomEmailTemplatesTab id="email-templates-tab" />
          </v-tab-item>
          <v-tab-item>
            <CustomLogosTab id="custom-logos-tab" />
          </v-tab-item>
          <v-tab-item>
            <CustomFaviconTab id="custom-favicon-tab" />
          </v-tab-item>
          <v-tab-item>
            <CustomTypographyTab id="custom-typography-tab" />
          </v-tab-item>
          <v-tab-item>
            <CustomColorPaletteTab id="custom-color-palette-tab" />
          </v-tab-item>
          <v-tab-item>
            <CustomCssTab id="custom-css-tab" />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>
